import { TranslationKeysByPath } from '@/localization';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type UnifiedProfileSectionHeaderProps = {
  labelKey: TranslationKeysByPath<'unifiedProfile'>;
  icon: ReactNode;
};

export const UnifiedProfileSectionHeader: FC<UnifiedProfileSectionHeaderProps> = ({ labelKey, icon }) => {
  const { t } = useTranslation('unifiedProfile');

  return (
    <div className='flex justify-between text-quaternary-400'>
      <p className='text-sm text-tertiary-600'>{t(labelKey) as any}</p>
      {icon}
    </div>
  );
};
